import { motion } from "framer-motion";
import { STATS, PARTNERS, LICENSES } from "@/data/content";

function Marquee({ items, reverse = false }) {
  const doubled = [...items, ...items];
  return (
    <div className="relative overflow-hidden mask-fade">
      <div className={`marquee-track ${reverse ? "marquee-slow" : ""}`}
        style={reverse ? { animationDirection: "reverse" } : undefined}>
        {doubled.map((p, i) => (
          <div
            key={`${p}-${i}`}
            className="mx-3 my-2 px-6 py-4 rounded-xl bg-[#0B1224]/70 border border-white/10 whitespace-nowrap text-sm font-medium text-gray-300"
          >
            {p}
          </div>
        ))}
      </div>
    </div>
  );
}

export default function StatsPartners() {
  return (
    <section className="relative py-24 lg:py-28" data-testid="home-stats">
      <div className="absolute inset-0 radial-glow-primary opacity-40" aria-hidden />
      <div className="relative mx-auto max-w-7xl px-6 lg:px-10">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
          {STATS.map((s, i) => (
            <motion.div
              key={s.label}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: i * 0.05 }}
              className="p-6 rounded-2xl bg-[#0B1224]/70 border border-white/10"
              data-testid={`stat-${i}`}
            >
              <div className="font-display text-4xl sm:text-5xl font-bold text-white tracking-tighter">
                <span className="text-gradient-blue">{s.value}</span>
              </div>
              <div className="mt-2 text-xs uppercase tracking-[0.2em] text-gray-500">{s.label}</div>
            </motion.div>
          ))}
        </div>

        <div className="mt-20">
          <div className="overline">Our iGaming Partners</div>
          <h3 className="mt-3 font-display text-2xl sm:text-3xl font-bold tracking-tight">
            120+ premium game providers.
          </h3>
          <div className="mt-8">
            <Marquee items={PARTNERS} />
          </div>
        </div>

        <div className="mt-20">
          <div className="overline">Licenses & Certifications</div>
          <h3 className="mt-3 font-display text-2xl sm:text-3xl font-bold tracking-tight">
            International iGaming licenses supported.
          </h3>
          <div className="mt-8">
            <Marquee items={LICENSES} reverse />
          </div>
        </div>
      </div>
    </section>
  );
}
